import { render, staticRenderFns } from "./TherapistDashModalCustomerPresent.vue?vue&type=template&id=17890bb8&scoped=true"
import script from "./TherapistDashModalCustomerPresent.vue?vue&type=script&lang=js"
export * from "./TherapistDashModalCustomerPresent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17890bb8",
  null
  
)

export default component.exports